module.exports = __webpack_public_path__ + "static/media/20x28no3.abbb318c.jpg";